var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonwloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e79bd;}.cls-2{fill:#2d3e50;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.95739,82.11254a6.95115,6.95115,0,0,0-8.90605,4.16184l-3.72153,10.2512a2.90051,2.90051,0,0,1-2.72006,1.90414H22.39291a2.906,2.906,0,0,1-2.72322-1.906l-3.721-10.24932a6.95117,6.95117,0,0,0-13.06789,4.744L6.6026,101.26995a16.85123,16.85123,0,0,0,15.79031,11.06192h83.21683a16.843,16.843,0,0,0,15.78847-11.064l3.721-10.24948A6.95114,6.95114,0,0,0,120.95739,82.11254Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.66688,66.17821V47.43306l-.01966-.02953-16.83785,11.53v-36.456a6.80941,6.80941,0,1,0-13.61881,0V58.86275L40.45609,47.40353l-.123.17955v18.5238L64.05163,82.348Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonwloadIcon);
export default __webpack_public_path__ + "static/media/donwload-icon.c71e4e95d38384028360da31a011e397.svg";
export { ForwardRef as ReactComponent };